import { dashboardConstants } from '../constants/dashboard';

const initialState = {
  sum: [],
  leads: 0,
  charts: [],
  totalCharts: {},
  referralStats: {},
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case dashboardConstants.SET_CHARTS_SUCCESS:
      return {
        ...state,
        charts: action.charts,
        totalCharts: action.totalCharts,
      };

    case dashboardConstants.SET_SUMMARY_SUCCESS:
      return {
        ...state,
        leads: action.leads,
        sum: action.sum,
      };
    case dashboardConstants.SET_DASHBOARD_REFERRAL_STATS_SUCCESS:
      return {
        ...state,
        referralStats: action.stats,
      };
    default:
      return state;
  }
};
